/*
 * Registers the Inbox page. Same shape as the other product pages: `PageBlueprint`,
 * `pluginId: 'app'`, `oss_apps/backstage` untouched.
 */
import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';

export const INBOX_PATH = '/inbox';

const inboxPage = PageBlueprint.make({
  name: 'stackschematic-inbox',
  params: {
    path: INBOX_PATH,
    loader: async () => {
      const { InboxPage } = await import('./InboxPage');
      return <InboxPage />;
    },
  },
});

export const stackSchematicInboxModule = createFrontendModule({
  pluginId: 'app',
  extensions: [inboxPage],
});
